module.exports = __webpack_public_path__ + "img/5.c4774e49.jpg";